var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.style === 1)?_c('template-one',{ref:"templateOne"}):_vm._e(),(_vm.style === 2)?_c('template-two',{ref:"templateTwo"}):(_vm.style === 3)?_c('div'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }